if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (this.hasAttribute("data-season-image")) {
          this.injectSeasonalPhoto();
        }
      }
  
      hide() {
        super.hide();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }

      injectSeasonalPhoto() {
        const seasonImage = this.getAttribute("data-season-image");
        const imgElement = document.createElement('img');
  
        imgElement.setAttribute('srcset', `${seasonImage}&width=550 550w,${seasonImage}&width=1100 1100w,${seasonImage}&width=1445 1445w,${seasonImage}&width=1680 1680w,${seasonImage}&width=2048 2048w,${seasonImage} 2048w`);
        imgElement.setAttribute('sizes', '(min-width: 750px) calc(100vw - 22rem), 1100px');
        imgElement.setAttribute('src', `${seasonImage}&width=1445`);
        imgElement.setAttribute('alt', 'Seasonal Image');
        imgElement.setAttribute('loading', 'lazy');
        imgElement.setAttribute('width', '1100');
        imgElement.setAttribute('height', '1467');
        imgElement.classList.add('seasonal-image');
        imgElement.setAttribute('data-media-id', `seasonal-image`);
        
        const imagesContainer = this.querySelector('.product-media-modal__content');
        if (imagesContainer) {
          imagesContainer.insertBefore(imgElement, imagesContainer.firstChild);
        }
      }
    });
  }
  